import { PropsWithChildren } from 'react';

import { useInitializeWidgetBrandWorkflowTags } from './hooks/useInitializeWidgetBrandWorkflowTags';
import Spinner from 'src/components/spinner';

interface SolveInsightsBrandFilterGuardProps {
  shouldHydrateCurrentUser: boolean;
}

const SolveInsightsBrandFilterGuard = ({
  children,
  shouldHydrateCurrentUser,
}: PropsWithChildren<SolveInsightsBrandFilterGuardProps>) => {
  const isBrandFilterReady = useInitializeWidgetBrandWorkflowTags(
    shouldHydrateCurrentUser,
  );

  if (!isBrandFilterReady) {
    return <Spinner height='100%' />;
  }

  return children;
};

export default SolveInsightsBrandFilterGuard;
